class Store {
    constructor() {
        this.user = null;
    }

    setUser(user) {
        this.user = user;
    }

    getUser() {
        return this.user;
    }
}

export default new Store();